import { onUnmounted, ref } from 'vue';

import { copyToClipBoard } from '@/utils';

export function useCopyToClipboard() {
  const hasCopied = ref(false);
  let timer: ReturnType<typeof setTimeout> | null = null;

  async function copy(text: string) {
    await copyToClipBoard(text);
    hasCopied.value = true;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      hasCopied.value = false;
    }, 1500);
  }

  onUnmounted(() => {
    if (timer) clearTimeout(timer);
  });

  return { hasCopied, copy };
}
